import { brandConfig } from './brand.config';

export const urlConfig = brandConfig.api;

export const apiBaseUrl = `${urlConfig.encryption ? 'https' : 'http'}://${urlConfig.host}:${urlConfig.port}`;
